import _ from 'underscore';
import {v4 as uuidv4} from 'uuid';

import {Selector} from 'notebook/ELNConstants';
import {CidIdMap} from 'notebook/notes/NoteConstants';

const SELECTOR_CID_PREFIX = 'selector';

const SelectorDAO = {
  makeSelector: (name: string, options?: Array<string>): Selector => {
    if (options === undefined) {
      options = [];
    }

    return {
      cid: _.uniqueId(SELECTOR_CID_PREFIX),
      staticId: uuidv4(),
      name,
      options,
    };
  },

  prepareForStore: (selector: Selector, cidIdMap: CidIdMap): Selector => {
    selector.cid = _.uniqueId(SELECTOR_CID_PREFIX);
    cidIdMap[selector.cid] = selector.cid;
    return selector;
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  prepareForSave: (selector: Selector, cidIdMap: CidIdMap) =>
    _.chain(selector).pick('cid', 'name', 'options', 'staticId').extend({id: cidIdMap[selector.cid]}).value(),
};

export default SelectorDAO;
